// Detect EU/EEA/UK based on timezone
export const isEURegion = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const euTimezones = [
      'Europe/London', 'Europe/Paris', 'Europe/Berlin', 'Europe/Madrid',
      'Europe/Rome', 'Europe/Amsterdam', 'Europe/Vienna', 'Europe/Brussels',
      'Europe/Dublin', 'Europe/Lisbon', 'Europe/Stockholm', 'Europe/Copenhagen',
      'Europe/Helsinki', 'Europe/Athens', 'Europe/Warsaw', 'Europe/Prague',
      'Europe/Budapest', 'Europe/Sofia', 'Europe/Bucharest', 'Europe/Zagreb',
      'Europe/Luxembourg', 'Europe/Malta', 'Europe/Nicosia', 'Europe/Riga',
      'Europe/Tallinn', 'Europe/Vilnius', 'Europe/Bratislava', 'Europe/Ljubljana'
    ];
    return euTimezones.includes(tz);
  } catch (e) {
    console.warn('Error detecting region from timezone:', e);
    return false;
  }
};
